var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4536_9790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10C6.55228 10 7 10.4477 7 11V14C7 14.5523 6.55228 15 6 15C5.44772 15 5 14.5523 5 14V11C5 10.4477 5.44772 10 6 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.00012C5 1.17832 6.62594 -0.263824 8.4965 0.0404748C10.0342 0.29065 11 1.69553 11 3.10711V7.16554L18.3065 8.494C20.4383 8.8816 21.8739 10.8961 21.5444 13.0377L19.9884 23.1522C19.9133 23.64 19.4936 24.0001 19 24.0001H6C5.69622 24.0001 5.40891 23.862 5.21914 23.6248L2.53397 20.2684C1.54098 19.0272 1 17.485 1 15.8954V13.0001C1 11.3433 2.34315 10.0001 4 10.0001H5V3.00012ZM8.17535 2.01452C7.53986 1.91115 7 2.39242 7 3.00012V11.0001C7 11.5524 6.55228 12.0001 6 12.0001H4C3.44771 12.0001 3 12.4478 3 13.0001V15.8954C3 17.0308 3.38642 18.1324 4.0957 19.019L6.48062 22.0001H18.1421L19.5677 12.7336C19.7324 11.6628 19.0146 10.6555 17.9487 10.4617L9.82111 8.98399C9.34562 8.89754 9 8.48341 9 8.00012V3.10711C9 2.5262 8.60428 2.08432 8.17535 2.01452Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4536_9790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.ddb620cef82beffe04c3c71a02ee6e88.svg";
export { ForwardRef as ReactComponent };